export { default } from './TermsOfUse';



// WEBPACK FOOTER //
// ./src/components/Help/TermsOfUse/index.ts